<template>
  <div class="isup-access-control-container">
    <el-card class="search-card">
      <div slot="header"><span>门禁设备</span></div>
      <el-row :gutter="12">
        <el-col :span="6">
          <el-input v-model="searchForm.deviceId" placeholder="请输入 DeviceID" clearable />
        </el-col>
        <el-col :span="6">
          <el-input v-model="searchForm.serialNo" placeholder="请输入设备型号" clearable />
        </el-col>
        <el-col :span="6">
          <el-input v-model="searchForm.machineName" placeholder="请输入门禁名称" clearable />
        </el-col>
        <el-col :span="6">
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-col>
      </el-row>
    </el-card>

    <el-card>
      <el-table v-loading="loading" :data="tableData" border>
        <el-table-column prop="deviceId" label="DeviceID" min-width="160" />
        <el-table-column prop="serialNo" label="设备型号" min-width="190" />
        <el-table-column prop="machineName" label="门禁名称" min-width="140">
          <template slot-scope="scope">{{ scope.row.machineName || '-' }}</template>
        </el-table-column>
        <el-table-column label="绑定状态" width="120" align="center">
          <template slot-scope="scope">
            <el-tag :type="bindTag(scope.row.bindState)">{{ bindText(scope.row.bindState) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="在线状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.online === 'Y' ? 'success' : 'info'">
              {{ scope.row.online === 'Y' ? '在线' : '离线' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="lastOnlineTime" label="最后上线" min-width="170" />
        <el-table-column label="操作" width="140" align="center" fixed="right">
          <template slot-scope="scope">
            <el-tooltip
              v-if="scope.row.bindState === '1200'"
              :content="scope.row.conflictReason || '设备身份冲突'"
              placement="top"
            >
              <el-button size="mini" disabled>禁止命名</el-button>
            </el-tooltip>
            <el-button
              v-else
              size="mini"
              type="primary"
              @click="openNameDialog(scope.row)"
            >
              {{ scope.row.bindState === '1100' ? '修改名称' : '命名' }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page.sync="pagination.current"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pagination.size"
        :total="pagination.total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </el-card>

    <el-dialog
      :title="nameForm.bound ? '修改门禁名称' : '命名门禁'"
      :visible.sync="nameDialogVisible"
      width="420px"
      @closed="resetNameDialog"
    >
      <el-form ref="nameForm" :model="nameForm" :rules="nameRules" label-width="90px">
        <el-form-item label="门禁名称" prop="machineName">
          <el-input
            v-model.trim="nameForm.machineName"
            maxlength="50"
            show-word-limit
            placeholder="例如：小区东门"
          />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="nameDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="submitName">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { listIsupAccessControls, nameIsupAccessControl } from '@/api/machine/isupAccessControlApi'

export default {
  name: 'IsupAccessControlList',
  data() {
    return {
      loading: false,
      saving: false,
      searchForm: { deviceId: '', serialNo: '', machineName: '' },
      tableData: [],
      pagination: { current: 1, size: 10, total: 0 },
      nameDialogVisible: false,
      nameForm: { registryId: '', machineName: '', bound: false },
      nameRules: {
        machineName: [
          { required: true, message: '请填写门禁名称', trigger: 'blur' },
          { min: 1, max: 50, message: '门禁名称长度必须为1至50个字符', trigger: 'blur' }
        ]
      }
    }
  },
  created() { this.getList() },
  methods: {
    async getList() {
      this.loading = true
      try {
        const result = await listIsupAccessControls({
          ...this.searchForm,
          page: this.pagination.current,
          row: this.pagination.size
        })
        this.tableData = result.data || []
        this.pagination.total = result.total || 0
      } catch (error) {
        this.$message.error(error.message || '获取门禁设备失败')
      } finally {
        this.loading = false
      }
    },
    bindText(state) {
      return { '1000': '待命名', '1100': '已绑定', '1200': '身份冲突', '1300': '已停用' }[state] || '未知'
    },
    bindTag(state) {
      return { '1000': 'warning', '1100': 'success', '1200': 'danger', '1300': 'info' }[state] || 'info'
    },
    openNameDialog(row) {
      this.nameForm = {
        registryId: row.registryId,
        machineName: row.machineName || '',
        bound: row.bindState === '1100'
      }
      this.nameDialogVisible = true
    },
    submitName() {
      this.$refs.nameForm.validate(async valid => {
        if (!valid || this.saving) return
        this.saving = true
        try {
          await nameIsupAccessControl(this.nameForm)
          this.$message.success('门禁名称保存成功')
          this.nameDialogVisible = false
          this.getList()
        } catch (error) {
          this.$message.error(error.message || '保存门禁名称失败')
        } finally {
          this.saving = false
        }
      })
    },
    resetNameDialog() {
      this.nameForm = { registryId: '', machineName: '', bound: false }
      if (this.$refs.nameForm) this.$refs.nameForm.clearValidate()
    },
    handleSearch() { this.pagination.current = 1; this.getList() },
    handleReset() {
      this.searchForm = { deviceId: '', serialNo: '', machineName: '' }
      this.handleSearch()
    },
    handleSizeChange(size) { this.pagination.size = size; this.getList() },
    handleCurrentChange(page) { this.pagination.current = page; this.getList() }
  }
}
</script>

<style lang="scss" scoped>
.isup-access-control-container {
  padding: 20px;
  .search-card { margin-bottom: 20px; }
  .el-pagination { margin-top: 20px; text-align: right; }
}
</style>
